import styled from "styled-components";

export const NoItemInOrder = styled.section`
  display: flex;
  height: calc(100vh - 4rem);
  width: 100%;
  padding: 0 20px;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  max-width: 600px;
  flex: 0.5;
  margin: 0 auto;
`;

export const NoItemInOrderSection = styled.div`
  width: fit-content;
  height: auto;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
`;

export const NoItemInOrderText = styled.span`
  text-align: center;
  width: 90%;

  @media screen and (min-width: 767px) {
    font-size: 20px;
    padding: 40px 0;
    margin: 0 auto;
  }

  @media screen and (max-width: 766px) {
    padding: 30px 0;
    margin: 0 auto;
    font-size: 12px;
  }
`;

export const NoFound = styled.p`
  margin: 0;
  text-align: center;
  font: normal normal normal 14px/18px Montserrat;
  letter-spacing: 0.36px;
  color: #777777;
`;